import {connect} from 'react-redux';
import { findIndex } from 'lodash';
import {ResultsComparisonPhotosynthesis as Component} from './ResultsComparisonPhotosynthesis';
import {} from '@learningblocks/protocol-redux/lib/Actions';

function mapStateToProps(state, ownProps) {

  return {
    colorPrediction: state.notebook.levelData.GENERIC_CHAPTERS.PREDICTIONS.components[findIndex(state.notebook.levelData.GENERIC_CHAPTERS.PREDICTIONS.components, {type: "COLOR_PREDICTION"})],
    interactionProps: {
      glassTubes: state.notebook.protocolSection.scene.apparatus.glassTubes,
      //agaroseGel: state.notebook.protocolSection.scene.apparatus.agaroseGel
    },
    level: state.notebook.levelSelected.id
  }

}

function mapDispatchToProps(dispatch) {
  return {};
}

export const ResultsComparisonPhotosynthesis = connect(
  mapStateToProps,
  mapDispatchToProps
)(Component);
